import React from "react"
import { AtribuirBairrosContextProvider } from "./context/AtribuirBairrosContextProvider"
import { AtribuirBairros } from "./AtribuirBairros"

export function Index() {
    return (
        <AtribuirBairrosContextProvider>
            <AtribuirBairros />
        </AtribuirBairrosContextProvider>
    )
}
